import { CSSProperties, FC, ReactNode } from "react";

import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classNames from "classnames";

interface FrameProps {
  title?: ReactNode;
  actions?: ReactNode;
  style?: CSSProperties;
  className?: string;
  collapsible?: boolean;
  defaultOpen?: boolean;
}

const Frame: FC<FrameProps> = ({ title, actions, style, className, collapsible, defaultOpen = true, children }) => {
  // If the frame is collapsible, wrap things in a Material UI Accordion
  if (collapsible) {
    return (
      <Accordion
        defaultExpanded={defaultOpen}
        className={classNames("rounded-md border border-border bg-white", className)}
        style={style}
      >
        {(title || actions) && (
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="flex justify-between items-center w-full">
              {typeof title === "string" ? <span className="font-bold text-[16px]">{title}</span> : title}
              {actions}
            </div>
          </AccordionSummary>
        )}
        <AccordionDetails>
          <div className="w-full">{children}</div>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <div
      className={classNames("flex flex-col overflow-hidden rounded-md border border-border bg-white", className)}
      style={{ ...style, flexShrink: 0 }}
    >
      {(title || actions) && (
        <div className="border-b border-border flex justify-between items-center h-[53px] px-[16px] py-[12px]">
          {typeof title === "string" ? <span className="font-bold text-[16px]">{title}</span> : title}
          {actions}
        </div>
      )}
      {children && <div className="overflow-auto h-full relative">{children}</div>}
    </div>
  );
};

export default Frame;
